import React from "react";
import IconChevronRight from "../Icons/IconChevronRight";

import { ActionCardProps, ActionCardContentProps } from "./ActionCard.types";

import {
  ActionCardWrapper,
  ActionCardMedia,
  ActionCardBody,
  ActionCardProjectId,
  ActionCardTitle,
  ActionCardDescription,
  ActionCardFooter,
  ActionCardArrow,
} from "./ActionCard.styles";

const ActionCardContent: React.FC<ActionCardContentProps> = ({
  children,
  media,
  onClick,
  showArrow = true,
  projectId,
  title,
  titleAs = "h3",

  stories,
  sqft,
  // budget,
}) => {
  return (
    <ActionCardWrapper
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onClick?.();
      }}
    >
      {media && <ActionCardMedia>{media}</ActionCardMedia>}

      <ActionCardBody>
        {projectId && <ActionCardProjectId>{projectId}</ActionCardProjectId>}

        {title && <ActionCardTitle as={titleAs}>{title}</ActionCardTitle>}

        <ActionCardDescription>{children}</ActionCardDescription>

        {(stories || sqft || budget) && (
          // <ActionCardFooter>
          //   {stories} Stories | {sqft} sq ft | ${budget} budget
          // </ActionCardFooter>
          <ActionCardFooter>
            <span>
              {stories} {Number(stories) === 1 ? "Story" : "Stories"}
            </span>
            <span className="dot">•</span>
            <span>{sqft} sq ft</span>
            {/* <span className="dot">•</span>
            <span>${budget} budget</span> */}
          </ActionCardFooter>
        )}
      </ActionCardBody>

      {showArrow && (
        <ActionCardArrow>
          <IconChevronRight size={3} />
        </ActionCardArrow>
      )}
    </ActionCardWrapper>
  );
};

export const ActionCard: React.FC<ActionCardProps> = ({
  isLoading,
  ...rest
}) => {
  if (isLoading) return <div>Loading...</div>;

  return <ActionCardContent {...rest} />;
};

export default ActionCard;
